export default class AppraisalManager {
    static selectedAppraisalData = null;
    static setAppraisalData(data) {
        AppraisalManager.selectedAppraisalData = data;
    }
    static getAppraisalData() {
        return AppraisalManager.selectedAppraisalData;
    }
}